import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function Hero() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-[55vh] sm:min-h-[65vh] flex items-center justify-center overflow-hidden pt-36 pb-14 sm:pt-48 sm:pb-20">
      {/* Full Width Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://assets.auxodev.dk/assets/e2460b72-5386-46d7-9851-4a7b448e2c89/4c8d59aa-f867-43d4-a5a9-779f6b9d3841.jpg"
          alt="Balsby Montage Smedearbejde"
          className="w-full h-full object-cover object-center"
        />
        {/* Transparent top, fading to black at the bottom */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/50 to-black" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-8 sm:py-12 flex flex-col items-center">
        {/* Centered Text Content */}
        <div className="text-center max-w-4xl mx-auto flex flex-col items-center">
          {/* Heading */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium tracking-wider text-white uppercase leading-[1.15]">
            Solidt håndværk & <br />
            professionelle løsninger
          </h1>

          {/* Description */}
          <p className="mt-4 text-sm sm:text-base md:text-lg text-slate-200 max-w-2xl font-medium leading-relaxed">
            Balsby Montage ApS leverer kompromisløs kvalitet inden for svejsearbejde, vandbehandling, mekanikerarbejde, montage samt udvikling og produktion af have-/parkmaskiner.
          </p>

          {/* CTAs */}
          <div className="mt-6 flex flex-col sm:flex-row gap-3 w-full sm:w-auto justify-center">
            <button
              onClick={() => scrollToSection('kontakt')}
              className="group flex items-center justify-center gap-2 bg-[#487aad] hover:bg-[#3b6591] text-white font-bold px-6 py-3 text-sm sm:text-base transition-all duration-200 shadow-md shadow-[#487aad]/10 hover:shadow-[#487aad]/20 cursor-pointer"
            >
              Få et uforpligtende tilbud
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </button>
          </div>

          {/* Key Highlights */}
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 w-full max-w-2xl border-t border-white/10 pt-6">
            <div>
              <div className="text-xl sm:text-2xl font-black text-white">100%</div>
              <div className="text-xs text-slate-300 font-semibold mt-0.5">Dansk kvalitet</div>
            </div>
            <div>
              <div className="text-xl sm:text-2xl font-black text-white">Præcision</div>
              <div className="text-xs text-slate-300 font-semibold mt-0.5">Højeste standarder</div>
            </div>
            <div>
              <div className="text-xl sm:text-2xl font-black text-white">Erfaren</div>
              <div className="text-xs text-slate-300 font-semibold mt-0.5">Faglig ekspertise</div>
            </div>
            <div>
              <div className="text-xl sm:text-2xl font-black text-white">Fleksibel</div>
              <div className="text-xs text-slate-300 font-semibold mt-0.5">Skræddersyet</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
